import { Action } from "@/App/actions";
import { ActionTypes } from "@/App/constants/actionTypes";
import { DrugTypes } from "@/types";

export interface DrugState {
  drugSearchResults: {
    results: Array<DrugTypes.DrugSearchResult>;
    result_count: string;
  };
  drugSearchOptions: DrugTypes.DrugSearchOptions;
  selectedDrugs: Array<DrugTypes.DrugResult>;
}

const DEFAULT_DRUG_STATE: DrugState = {
  drugSearchResults: {
    results: [],
    result_count: null,
  },
  drugSearchOptions: {
    order_by: [],
    page_number: 1,
    results_per_page: 20,
  },
  selectedDrugs: [],
};

export default (state: DrugState = DEFAULT_DRUG_STATE, action: Action): DrugState => {
  if (action.type === ActionTypes.SEARCH_FOR_DRUG) {
    return {
      ...state,
      drugSearchOptions: action.payload,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_DRUG_RESULTS) {
    return {
      ...state,
      drugSearchResults: action.payload,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_SELECTED_DRUGS) {
    return {
      ...state,
      selectedDrugs: action.payload,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_SELECTED_DRUGS_RESULTS) {
    return {
      ...state,
      selectedDrugs: action.payload,
    };
  } else if (action.type === ActionTypes.ADD_SELECTED_DRUG) {
    for (const drug of state.selectedDrugs) {
      if (action.payload.ndc === drug.ndc) {
        return state;
      }
    }

    return {
      ...state,
      selectedDrugs: [...state.selectedDrugs, action.payload],
    };
  } else if (action.type === ActionTypes.ADD_CURRENT_SELECTED_DRUG) {
    return {
      ...state,
      selectedDrugs: action.payload,
    };
  } else if (action.type === ActionTypes.REMOVE_SELECTED_DRUG) {
    const newSelectedDrugs = state.selectedDrugs.filter((drug: DrugTypes.DrugResult) => {
      return drug.ndc !== action.payload.ndc;
    });

    return {
      ...state,
      selectedDrugs: newSelectedDrugs,
    };
  } else {
    return state;
  }
};
